import { createContext, useContext } from 'react';

export type PillRadioButtonGroupContextData = {
  value: string | number | boolean;
  disabled: boolean;
  onClick: (value: string | number | boolean) => void;
};

export const PillRadioButtonGroupContext = createContext<PillRadioButtonGroupContextData | null>(null);

export const usePillRadioButtonGroupContext = () => useContext(PillRadioButtonGroupContext);
